module.exports = __webpack_public_path__ + "static/media/СЗФО_2002.6d29ca77.png";